<template>
  <div class="wrapper">
    <div class="tab-options">
      <div class="filter-widget">
        <div class="search-widget">
          <div class="search-group">
            <img class="search" src="@/assets/icons/search.svg" />
            <input
              @keyup="searchAccount"
              placeholder="Search"
              type="Type in to Search"
            />
          </div>
        </div>
        <div class="filter-select-widget divider">
          <img src="@/assets/admin-icon/filter.svg" />
          <filter-select v-model="sort_filter_data" :content="sort_filter"
            >Filter</filter-select
          >
        </div>
      </div>
      <button class="btn-add" @click="addNew()">
        <span>Add Account </span>
        <img src="@/assets/admin-icon/white-circle-plus.svg" />
      </button>
    </div>
    <div class="tab-body">
      <table class="table-data">
        <thead class="table-header">
          <tr>
            <th>Name</th>

            <th class="phone-hide">Phone</th>
            <th class="phone-hide">Email</th>
            <th class="phone-hide">Location</th>
            <th></th>
          </tr>
        </thead>
        <tbody class="table-body">
          <template v-for="(item, index) in accounts_data">
            <tr :key="index">
              <td
                @click="
                  $router.push({
                    name: 'account-view',
                    params: { type: 'overview', id: item.id },
                  })
                "
              >
                <div class="profile-content">
                  <div class="profile-alphabet">
                    <span>{{ $nameInitials(item.name) | validate }}</span>
                  </div>
                  {{ item.name | validate }}
                </div>
              </td>
              <td class="phone-hide">
                {{ item.phone | validate }}
              </td>

              <td class="phone-hide">
                {{ item.email | validate }}
              </td>
              <td class="phone-hide">
                {{ item.location | validate }}
              </td>
              <td>
                <dropdownMenu>
                  <ul>
                    <li>
                      <a @click="updateAccount(item)">Update</a>
                    </li>
                    <li>
                      <app-dialog
                        title="Delete Account"
                        ask="Are you sure you want to permanently delete this account?"
                        yesText="Delete"
                        noText="Cancel"
                        @onComfirm="deleteAccount(item.id)"
                      >
                        <a href="#">Delete</a>
                      </app-dialog>
                    </li>
                  </ul>
                </dropdownMenu>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>

    <!-- Add - Update Modal -->
    <div class="overlay" v-if="show_form_add_update">
      <div class="form-widget-modal">
        <div class="moder-header">
          <h4 v-if="!account_form.id">Add a new account</h4>
          <h4 v-else>Update Accounts</h4>
        </div>
        <div class="modal-body">
          <div class="input-group">
            <label>Account name*</label>
            <input type="text" v-model="account_form.name" class="input-form" />
          </div>

          <div class="input-group">
            <label>Description</label>
            <textarea
              type="text"
              v-model="account_form.description"
              class="input-form"
            ></textarea>
          </div>
          <div class="twin-input">
            <div class="input-group">
              <label>Phone</label>
              <input
                type="text"
                v-model="account_form.phone"
                class="input-form"
              />
            </div>
            <div class="input-group">
              <label>Email</label>
              <input
                type="text"
                v-model="account_form.email"
                class="input-form"
              />
            </div>
          </div>
          <div class="twin-input">
            <div class="input-group">
              <label>Location</label>
              <map-helper v-model="account_form.location"></map-helper>
            </div>
            <div class="input-group">
              <label>Corporate identity</label>
              <input
                type="text"
                v-model="account_form.corporate_identity"
                class="input-form"
              />
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <c-button
            :loading="adding_acc_loading"
            @click="submitAccountData"
            class="btn-save"
            >Save</c-button
          >
          <button class="btn-cancel" @click="show_form_add_update = false">
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data: () => ({
    show_form_add_update: false,
    tag_filter_data: "",
    sort_filter_data: "",
    sort_filter: [
      {
        value: "create_date",
        name: "Create Date",
      },
      {
        value: "name",
        name: "Name",
      },
    ],
    account_form: {
      id: null,
      account_id: null,
      name: "",
      description: "",
      phone: "",
      email: "",
      location: "",
      corporate_identity: "",
    },
    adding_acc_loading: false,
    accounts_data: [],
  }),
  mounted() {
    let vm = this;
    vm.getAccountsData();
  },
  methods: {
    searchAccount({ target }) {
      let vm = this;
      vm.$store
        .dispatch("ACCOUNT_SEARCH", {
          query: target.value,
        })
        .then((response) => {
          vm.accounts_data = response.data;
        })
        .catch((error) => {});
    },
    deleteAccount(id) {
      let vm = this;
      vm.$store
        .dispatch("ACCOUNT_DELETE", { account_id: id })
        .then((response) => {
          vm.getAccountsData();
        })
        .catch((error) => {
          console.error({ error });
        });
    },
    updateAccount(item) {
      let vm = this;
      vm.account_form.id = item.id;
      vm.account_form.account_id = item.id;
      vm.account_form.name = item.name;
      vm.account_form.description = item.description;
      vm.account_form.phone = item.phone;
      vm.account_form.email = item.email;
      vm.account_form.location = item.location;
      vm.account_form.corporate_identity = item.corporate_identity;
      vm.show_form_add_update = true;
    },
    getAccountsData() {
      let vm = this;
      vm.$store.dispatch("LOADER_START");
      vm.$store
        .dispatch("ACCOUNT_GET_DATA")
        .then((response) => {
          vm.accounts_data = response.data;
          vm.$store.dispatch("LOADER_CLOSE");
        })
        .catch((error) => {
          vm.$store.dispatch("LOADER_CLOSE");
          console.error({ error });
        });
    },
    submitAccountData() {
      let vm = this;
      const rules = {
        name: {
          run: (value) => {
            if (value && value.length > 0) {
              return false;
            }
            return "Account name can not be empty";
          },
        },
        email: {
          run: (value) => {
            if (value) {
              const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
              if (re.test(String(value).toLowerCase())) {
                return false;
              }
            }
            return false;
          },
        },
      };
      if (vm.$isFieldsValidated(vm.account_form, rules)) {
        vm.adding_acc_loading = true;
        if (!vm.account_form.id) {
          vm.$store
            .dispatch("ACCOUNT_ADD_NEW", vm.account_form)
            .then((response) => {
              vm.adding_acc_loading = false;
              vm.show_form_add_update = false;
              vm.getAccountsData();
            })
            .catch((error) => {
              console.error({ error });
              vm.adding_acc_loading = false;
            });
        } else {
          vm.$store
            .dispatch("ACCOUNT_UPDATE", vm.account_form)
            .then((response) => {
              vm.adding_acc_loading = false;
              vm.show_form_add_update = false;
              vm.getAccountsData();
            })
            .catch((error) => {
              console.error({ error });
              vm.adding_acc_loading = false;
            });
        }
      }
    },
    addNew() {
      let vm = this;
      vm.show_form_add_update = true;
      vm.account_form = {
        id: null,
        account_id: null,
        name: "",
        description: "",
        phone: "",
        email: "",
        location: "",
        corporate_identity: "",
      };
    },
    filterBySort(val) {
      let vm = this;
      vm.$store
        .dispatch("ACCOUNT_FILTER_BY_SORT", {
          option: val,
        })
        .then((response) => {
          vm.accounts_data = response.data;
        })
        .catch((error) => {});
    },
  },
  watch: {
    sort_filter_data(val) {
      let vm = this;
      vm.filterBySort(val);
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  .tab-options {
    @media (min-width: 300px) and (max-width: 630px) {
      left: unset;
    }
    .filter-widget {
      .search-widget {
        @media (min-width: 300px) and (max-width: 630px) {
          display: none;
        }
      }
    }
  }

  .phone-hide {
    @media (min-width: 300px) and (max-width: 630px) {
      display: none;
    }
  }
  .form-widget-modal {
    width: 500px;
  }
}
</style>
